import { Link } from 'react-router-dom';

const quickLinks = [
  { label: '首页', to: '/' },
  { label: '韩国伦理剧', to: '/category/ethical-drama' },
  { label: '热门推荐', to: '/category/popular' },
  { label: '专题合集', to: '/special' },
  { label: '关于我们', to: '/about' },
];

export default function SiteFooter() {
  return (
    <footer className="mt-auto w-full bg-primary-900 text-background-100">
      <div className="mx-auto max-w-[1200px] px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500">
                <i className="ri-movie-2-line text-lg text-primary-950" />
              </span>
              <span className="font-heading text-lg font-bold tracking-wide text-background-50">韩国伦理剧专题</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-200">
              专注于韩国伦理剧的剧情介绍、专题解析与剧集推荐，帮助影视剧爱好者发现并读懂高质量的家庭与情感题材作品。
            </p>
            <p className="mt-4 text-xs leading-relaxed text-primary-200">
              本站所有剧集信息均为演示示例，旨在展示网站功能；不含播放、下载、登录及付费等任何数据接口服务。
            </p>
          </div>

          <div>
            <h4 className="mb-4 font-heading text-sm font-semibold text-background-50">
              <a href="/" className="cursor-pointer">内容导航</a>
            </h4>
            <ul className="flex flex-col gap-2.5">
              {quickLinks.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="cursor-pointer text-sm text-background-200 transition-colors hover:text-accent-300">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="mb-4 font-heading text-sm font-semibold text-background-50">
              <a href="/about" className="cursor-pointer">联系我们</a>
            </h4>
            <ul className="flex flex-col gap-2.5 text-sm text-background-200">
              <li className="flex items-center gap-2">
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-mail-line text-sm" />
                </span>
                hello@kdrama-portal.example
              </li>
              <li className="flex items-center gap-2">
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-map-pin-line text-sm" />
                </span>
                首尔特别市江南区论岘路
              </li>
              <li className="flex items-center gap-2">
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-time-line text-sm" />
                </span>
                周一至周五 10:00 - 19:00
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-3 border-t border-primary-700 pt-6 text-xs text-primary-200 sm:flex-row sm:items-center">
          <p>© 2025 韩国伦理剧专题 · 本站为演示站点，内容仅供学习参考</p>
          <p className="flex flex-wrap items-center gap-4">
            <Link to="/about" className="cursor-pointer transition-colors hover:text-accent-300">使用说明</Link>
            <Link to="/about" className="cursor-pointer transition-colors hover:text-accent-300">免责声明</Link>
            <Link to="/special" className="cursor-pointer transition-colors hover:text-accent-300">专题合集</Link>
          </p>
        </div>
      </div>
    </footer>
  );
}